import { MotionWrapper } from './MotionWrapper';

export default MotionWrapper;
